import { Badge } from "@/components/ui/badge";
import { FileWarning, FilePen, Eye, CheckCircle2 } from "lucide-react";

const MAP = {
  draft_needed: { label: "Draft Needed", cls: "bg-slate-200 text-slate-800 hover:bg-slate-200", Icon: FilePen },
  missing_info: { label: "Missing Info", cls: "bg-warning text-warning-foreground hover:bg-warning", Icon: FileWarning },
  under_review: { label: "Under Review", cls: "bg-primary text-primary-foreground hover:bg-primary", Icon: Eye },
  finalized: { label: "Finalized", cls: "bg-success text-success-foreground hover:bg-success", Icon: CheckCircle2 },
};

export function StatusBadge({ status }) {
  const m = MAP[status] || MAP.draft_needed;
  const { Icon } = m;
  return (
    <Badge data-testid="case-status-badge" className={`rounded-full gap-1.5 px-3 py-1 font-semibold ${m.cls}`}>
      <Icon className="h-3.5 w-3.5" />
      {m.label}
    </Badge>
  );
}
